import React, { useEffect, useState } from 'react';

interface SuccessCelebrationProps {
  show: boolean;
  onComplete?: () => void;
}

interface Confetti {
  id: number;
  left: number;
  animationDelay: number;
  color: string;
}

const SuccessCelebration: React.FC<SuccessCelebrationProps> = ({ show, onComplete }) => {
  const [confetti, setConfetti] = useState<Confetti[]>([]);

  useEffect(() => {
    if (show) {
      const colors = ['#00366D', '#80BC5C', '#C7D655', '#EE8435', '#E64853', '#6AA2D6'];
      const pieces: Confetti[] = Array.from({ length: 50 }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        animationDelay: Math.random() * 0.5,
        color: colors[Math.floor(Math.random() * colors.length)],
      }));

      setConfetti(pieces);

      const timeout = setTimeout(() => {
        setConfetti([]);
        onComplete?.();
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [show, onComplete]);

  if (!show || confetti.length === 0) {
    return null;
  }

  return (
    <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden">
      {confetti.map((piece) => (
        <div
          key={piece.id}
          className="absolute top-0 w-2 h-2 rounded-full animate-confetti-fall"
          style={{
            left: `${piece.left}%`,
            backgroundColor: piece.color,
            animationDelay: `${piece.animationDelay}s`,
          }}
        />
      ))}
    </div>
  );
};

export default SuccessCelebration;
